<template>
    <div>
        <el-dialog title="选择角色" width="800px" :visible.sync="selectRoleVisible" :append-to-body="true" center :before-close="cancelRoleData" :close-on-click-modal="false">
            <!-- 查询条件 -->
            <el-form id="formID" :inline="true" :model="queryParams" style="border-radius:3px;margin-bottom:10px; box-shadow:0px 1px 0px 0px rgba(0, 0, 0, 0.1);" class="demo-form-inline">
                <el-form-item label="用户名称" prop="nickName">
                    <el-input v-model="queryParams.nickName" disabled></el-input>
                </el-form-item>
                <el-form-item label="登录账号" prop="userName">
                    <el-input v-model="queryParams.userName" disabled />
                </el-form-item>
            </el-form>
            <!-- 表格 -->
            <el-table 
                ref="tableRef"
                :row-key="getRowKey"
                :data="roles.slice((queryParams.pageNum - 1) * queryParams.pageSize, queryParams.pageNum * queryParams.pageSize)" 
                @row-click="clickRow"
                border 
                :style="{ height: tableHeight + 'px',width:'100%','border-radius':'3px'}" 
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="50" align="center" />
                <el-table-column type="index" label="序号" width="80" align="center" />
                <el-table-column label="角色编号" align="center" prop="roleId" />
                <el-table-column label="角色名称" align="center" prop="roleName" />
                <el-table-column label="权限字符" align="center" prop="roleKey" />
                <el-table-column label="创建时间" align="center" prop="createTime" width="180" />
            </el-table>

            <!-- 分页 -->
            <div class="block" style="background:#fff;text-align:center;padding:20px 0;">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryParams.pageNum"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="queryParams.pageSize"
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
            <template #footer>
                <div class="dialog-footer">
                <el-button type="primary" @click="submitRoleData">确 定</el-button>
                <el-button @click="cancelRoleData">取 消</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>
<script>
import { Message } from 'element-ui';
export default {
    name: 'AssignRoles',
    props: {
        roleId: {
            type: String,
            required: true
        },
        selectRoleVisible:{
            type:Boolean,
            required:true
        }
    },
    data(){
        return{
            // 查询条件
            queryParams: {
                pageNum:1,
                pageSize: 10,
                nickName:"",
                userName:"",
                userId:""
            },
            total:0,
            tableHeight:650,
            // 表格数据
            roles:[],
            roleIds:[]//选中的数据
        }
    },
    mounted() {
        this.queryParams.roleId = this.roleId;
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
        this.getList();
    },
    methods: {
        // 监听窗口缩放
        handleResize(){
            // 当窗口大小变化时，这个函数会被调用
            const height = window.innerHeight;
            let dom = document.getElementById("formID");
            let formH = 70;//一行时高度为70
            if(dom){
                formH = dom.offsetHeight;
            }
            this.tableHeight = height-360-formH;//表单的高度会变化
            // 设置表格体高度
            let tableBody = document.getElementsByClassName("el-table__body-wrapper")[0];
            tableBody.style.height = (this.tableHeight-40)+"px";
        },
        /** 保存选中的数据编号 */
        getRowKey(row) {
            return String(row.roleId);
        },
        /** 单击选中行数据 */
        clickRow(row){
            row.flag = !row.flag
            this.$refs.tableRef?.toggleRowSelection(row, row.flag);
        },
        async getList(){
            if (this.roleId) {
                const res = await this.$store.dispatch('user/getAuthRole',this.roleId);
                Object.assign(this.queryParams, res.data.user);
                Object.assign(this.roles, res.data.roles);
                this.total = this.roles.length;
                this.$nextTick(() => {
                    this.roles.forEach((row) => {
                        if (row?.flag) {
                            this.$refs.tableRef?.toggleRowSelection(row, true);
                        }
                    });
                });
            }
        },
        // 选择
        handleSelectionChange(selection){
            this.roleIds = selection.map((item) => item.roleId);
        },
        // 行修改
        handleEdit(index,row) {
            console.log(index,row,"edit");
            this.dialogForm = row;
            this.dialogFormVisible = true;
        },
        // 确认添加
        submitRoleData(){
            const userId = this.queryParams.userId;
            const rIds = this.roleIds.join(',');
            if (rIds == '') {
                Message.warning('请选择要分配的角色');
                return;
            }
            this.$store.dispatch("user/updateAuthRole",{ userId, roleIds: rIds }).then((result)=>{
                if(result){
                    Message.success('授权成功');
                    this.$emit('ok');
                }
            }); 
        },
        cancelRoleData(){
            this.$emit('cancel');
        },
        handleSizeChange(val) {
            this.queryParams.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.getList();
        }
    }
}
</script>

<style lang="scss" scoped>
    .title-box{
        width: 100%;
        font-size: 16px;
        font-weight: bold;
        padding: 27px 0 15px;
        line-height: 16px;
    }
    // 表头背景色
    ::v-deep .custom-table-header th{
        background-color: #ebeef5 !important;
    }
    // 表格字体大小
    .el-table {
        font-size: 12px;
    }
    // 表单底部边界线
    .el-table::before {
        height: 0px;
    }
    // 表格字体
    ::v-deep .el-table thead {
        color: #606266;
    }
    // 表格内边距
    ::v-deep .el-table .el-table__cell {
        padding: 8px 0;
    }
    // 表单底部margin
    .el-form-item {
        margin-bottom: 0;
    }
    // 当前页码样式
    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #FF9F07;
    }
    // 页面hover样式
    .el-pagination.is-background .el-pager li:not(.disabled):hover {
        color: #FF9F07;
    }
    ::v-deep .el-dialog{
        border-radius: 5px;
    }
    ::v-deep .el-dialog__header {
        padding: 6px 19px;
        background: #B1CEF9;
        font-size: 16px;
        font-weight: bold;
        text-align: left;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    }   
    ::v-deep .el-dialog__headerbtn {
        font-size: 18px;
    }
    ::v-deep .el-dialog__headerbtn {
        top: 10px;
        right: 6px;
    }
    ::v-deep .el-dialog__body {
        padding: 15px 20px;
        border-bottom: 1px solid #D5D5D5;
    }
    // .el-button{
    //     font-size: 12px;
    // }
    ::v-deep .el-form-item__label {
        font-size: 12px;
    }
    ::v-deep .el-dialog__footer {
        padding: 20px;
    }
    ::v-deep .el-table__body-wrapper{
        // height: 100%;
        overflow-y: auto;
    }
</style>